module.exports = __webpack_public_path__ + "assets/img/jykj_title1.e99e0f2d.png";